import { Box } from "@mui/material"
import { useState } from "react";
import GlowMode from "../assets/oot/classic/GlowGoModeLigth.gif"
import GoMode from "../assets/oot/classic/GoModeLigth.gif"
import Triforce from "../assets/oot/classic/Triforce_Artwork.png"

const GoModeButton = () => {

    let [state, setState] = useState(0);

    const handleClick = () => {
        setState((state + 1) % 3)
    }

    const handleRightClick = () => {
        setState(0)
    }

    return <Box width={100} height={100} display={"flex"} justifyContent={"center"} alignItems={"center"} onClick={handleClick} onContextMenu={(e) => {e.preventDefault(); handleRightClick()}}>
        {state === 0 && <Box sx={{filter: "grayscale(100%) brightness(0.6)"}}><img src={Triforce} width={80} height={60} alt="triforce"/></Box>}
        {state === 1 && <img src={GlowMode} alt="GlowMode" width={100} height={100} />}
        {state === 2 && <img src={GoMode} alt="GoMode" width={100} height={100} />}
    </Box>
}

export default GoModeButton 